import Page from 'classes/Page'

export default class Default extends Page {
  constructor () {
    super({
      id: 'default',
      element: '.default',
      elements: {
        header: document.querySelector('.header'),
        // intro: '.contacts_intro'
      }
    })

    //console.log(this.elements);
  }
}
